/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';
import type { Customer } from './Customer';
import {
    CustomerFromJSON,
    CustomerFromJSONTyped,
    CustomerToJSON,
} from './Customer';
import type { CustomerRevenueBreakdown } from './CustomerRevenueBreakdown';
import {
    CustomerRevenueBreakdownFromJSON,
    CustomerRevenueBreakdownFromJSONTyped,
    CustomerRevenueBreakdownToJSON,
} from './CustomerRevenueBreakdown';
import type { GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInner } from './GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInner';
import {
    GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSON,
    GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSONTyped,
    GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerToJSON,
} from './GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInner';
import type { GetLightInvoicesResponseInvoicesInnerFixedLineItemsInner } from './GetLightInvoicesResponseInvoicesInnerFixedLineItemsInner';
import {
    GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSON,
    GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSONTyped,
    GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerToJSON,
} from './GetLightInvoicesResponseInvoicesInnerFixedLineItemsInner';
import type { GetLightInvoicesResponseInvoicesInnerUsageLineItemsInner } from './GetLightInvoicesResponseInvoicesInnerUsageLineItemsInner';
import {
    GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSON,
    GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSONTyped,
    GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerToJSON,
} from './GetLightInvoicesResponseInvoicesInnerUsageLineItemsInner';
import type { InvoiceBillingStatus } from './InvoiceBillingStatus';
import {
    InvoiceBillingStatusFromJSON,
    InvoiceBillingStatusFromJSONTyped,
    InvoiceBillingStatusToJSON,
} from './InvoiceBillingStatus';
import type { InvoiceCalculationStatus } from './InvoiceCalculationStatus';
import {
    InvoiceCalculationStatusFromJSON,
    InvoiceCalculationStatusFromJSONTyped,
    InvoiceCalculationStatusToJSON,
} from './InvoiceCalculationStatus';
import type { InvoicePaymentProviderInformation } from './InvoicePaymentProviderInformation';
import {
    InvoicePaymentProviderInformationFromJSON,
    InvoicePaymentProviderInformationFromJSONTyped,
    InvoicePaymentProviderInformationToJSON,
} from './InvoicePaymentProviderInformation';
import type { InvoiceReviewStatus } from './InvoiceReviewStatus';
import {
    InvoiceReviewStatusFromJSON,
    InvoiceReviewStatusFromJSONTyped,
    InvoiceReviewStatusToJSON,
} from './InvoiceReviewStatus';
import type { Period } from './Period';
import {
    PeriodFromJSON,
    PeriodFromJSONTyped,
    PeriodToJSON,
} from './Period';
import type { PromotionLineItem } from './PromotionLineItem';
import {
    PromotionLineItemFromJSON,
    PromotionLineItemFromJSONTyped,
    PromotionLineItemToJSON,
} from './PromotionLineItem';
import type { RevisionedLineItem } from './RevisionedLineItem';
import {
    RevisionedLineItemFromJSON,
    RevisionedLineItemFromJSONTyped,
    RevisionedLineItemToJSON,
} from './RevisionedLineItem';

/**
 * 
 * @export
 * @interface GetLightInvoicesResponseInvoicesInner
 */
export interface GetLightInvoicesResponseInvoicesInner {
    /**
     * 
     * @type {string}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    name: string;
    /**
     * 
     * @type {Customer}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    customer: Customer;
    /**
     * 
     * @type {Currency}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    currency: Currency;
    /**
     * 
     * @type {string}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    notes?: string;
    /**
     * 
     * @type {number}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    totalCommitment: number;
    /**
     * 
     * @type {number}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    taxRate: number;
    /**
     * 
     * @type {Date}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    issuedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    dueDate: Date;
    /**
     * 
     * @type {CustomerRevenueBreakdown}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    revenueBreakdown: CustomerRevenueBreakdown;
    /**
     * 
     * @type {Period}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    billingCycle: Period;
    /**
     * 
     * @type {string}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    purchaseOrder?: string;
    /**
     * 
     * @type {Array<GetLightInvoicesResponseInvoicesInnerFixedLineItemsInner>}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    fixedLineItems: Array<GetLightInvoicesResponseInvoicesInnerFixedLineItemsInner>;
    /**
     * 
     * @type {Array<GetLightInvoicesResponseInvoicesInnerUsageLineItemsInner>}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    usageLineItems: Array<GetLightInvoicesResponseInvoicesInnerUsageLineItemsInner>;
    /**
     * 
     * @type {Array<GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInner>}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    commitmentLineItems: Array<GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInner>;
    /**
     * 
     * @type {Array<PromotionLineItem>}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    promotionLineItems: Array<PromotionLineItem>;
    /**
     * 
     * @type {Array<RevisionedLineItem>}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    revisionedLineItems: Array<RevisionedLineItem>;
    /**
     * 
     * @type {number}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    paymentDueDays: number;
    /**
     * 
     * @type {InvoicePaymentProviderInformation}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    paymentProviderInformation?: InvoicePaymentProviderInformation;
    /**
     * 
     * @type {string}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    paymentTerm: GetLightInvoicesResponseInvoicesInnerPaymentTermEnum;
    /**
     * 
     * @type {InvoiceReviewStatus}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    reviewStatus: InvoiceReviewStatus;
    /**
     * 
     * @type {InvoiceBillingStatus}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    billingStatus: InvoiceBillingStatus;
    /**
     * 
     * @type {InvoiceCalculationStatus}
     * @memberof GetLightInvoicesResponseInvoicesInner
     */
    calculationStatus: InvoiceCalculationStatus;
}


/**
 * @export
 */
export const GetLightInvoicesResponseInvoicesInnerPaymentTermEnum = {
    Prepayment: 'Prepayment',
    Postpayment: 'Postpayment'
} as const;
export type GetLightInvoicesResponseInvoicesInnerPaymentTermEnum = typeof GetLightInvoicesResponseInvoicesInnerPaymentTermEnum[keyof typeof GetLightInvoicesResponseInvoicesInnerPaymentTermEnum];


/**
 * Check if a given object implements the GetLightInvoicesResponseInvoicesInner interface.
 */
export function instanceOfGetLightInvoicesResponseInvoicesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "customer" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "totalCommitment" in value;
    isInstance = isInstance && "taxRate" in value;
    isInstance = isInstance && "issuedAt" in value;
    isInstance = isInstance && "dueDate" in value;
    isInstance = isInstance && "revenueBreakdown" in value;
    isInstance = isInstance && "billingCycle" in value;
    isInstance = isInstance && "fixedLineItems" in value;
    isInstance = isInstance && "usageLineItems" in value;
    isInstance = isInstance && "commitmentLineItems" in value;
    isInstance = isInstance && "promotionLineItems" in value;
    isInstance = isInstance && "revisionedLineItems" in value;
    isInstance = isInstance && "paymentDueDays" in value;
    isInstance = isInstance && "paymentTerm" in value;
    isInstance = isInstance && "reviewStatus" in value;
    isInstance = isInstance && "billingStatus" in value;
    isInstance = isInstance && "calculationStatus" in value;

    return isInstance;
}

export function GetLightInvoicesResponseInvoicesInnerFromJSON(json: any): GetLightInvoicesResponseInvoicesInner {
    return GetLightInvoicesResponseInvoicesInnerFromJSONTyped(json, false);
}

export function GetLightInvoicesResponseInvoicesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLightInvoicesResponseInvoicesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'customer': CustomerFromJSON(json['customer']),
        'currency': CurrencyFromJSON(json['currency']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'totalCommitment': json['totalCommitment'],
        'taxRate': json['taxRate'],
        'issuedAt': (new Date(json['issuedAt'])),
        'dueDate': (new Date(json['dueDate'])),
        'revenueBreakdown': CustomerRevenueBreakdownFromJSON(json['revenueBreakdown']),
        'billingCycle': PeriodFromJSON(json['billingCycle']),
        'purchaseOrder': !exists(json, 'purchaseOrder') ? undefined : json['purchaseOrder'],
        'fixedLineItems': ((json['fixedLineItems'] as Array<any>).map(GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerFromJSON)),
        'usageLineItems': ((json['usageLineItems'] as Array<any>).map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerFromJSON)),
        'commitmentLineItems': ((json['commitmentLineItems'] as Array<any>).map(GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerFromJSON)),
        'promotionLineItems': ((json['promotionLineItems'] as Array<any>).map(PromotionLineItemFromJSON)),
        'revisionedLineItems': ((json['revisionedLineItems'] as Array<any>).map(RevisionedLineItemFromJSON)),
        'paymentDueDays': json['paymentDueDays'],
        'paymentProviderInformation': !exists(json, 'paymentProviderInformation') ? undefined : InvoicePaymentProviderInformationFromJSON(json['paymentProviderInformation']),
        'paymentTerm': json['paymentTerm'],
        'reviewStatus': InvoiceReviewStatusFromJSON(json['reviewStatus']),
        'billingStatus': InvoiceBillingStatusFromJSON(json['billingStatus']),
        'calculationStatus': InvoiceCalculationStatusFromJSON(json['calculationStatus']),
    };
}

export function GetLightInvoicesResponseInvoicesInnerToJSON(value?: GetLightInvoicesResponseInvoicesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'customer': CustomerToJSON(value.customer),
        'currency': CurrencyToJSON(value.currency),
        'notes': value.notes,
        'totalCommitment': value.totalCommitment,
        'taxRate': value.taxRate,
        'issuedAt': (value.issuedAt.toISOString()),
        'dueDate': (value.dueDate.toISOString()),
        'revenueBreakdown': CustomerRevenueBreakdownToJSON(value.revenueBreakdown),
        'billingCycle': PeriodToJSON(value.billingCycle),
        'purchaseOrder': value.purchaseOrder,
        'fixedLineItems': ((value.fixedLineItems as Array<any>).map(GetLightInvoicesResponseInvoicesInnerFixedLineItemsInnerToJSON)),
        'usageLineItems': ((value.usageLineItems as Array<any>).map(GetLightInvoicesResponseInvoicesInnerUsageLineItemsInnerToJSON)),
        'commitmentLineItems': ((value.commitmentLineItems as Array<any>).map(GetLightInvoicesResponseInvoicesInnerCommitmentLineItemsInnerToJSON)),
        'promotionLineItems': ((value.promotionLineItems as Array<any>).map(PromotionLineItemToJSON)),
        'revisionedLineItems': ((value.revisionedLineItems as Array<any>).map(RevisionedLineItemToJSON)),
        'paymentDueDays': value.paymentDueDays,
        'paymentProviderInformation': InvoicePaymentProviderInformationToJSON(value.paymentProviderInformation),
        'paymentTerm': value.paymentTerm,
        'reviewStatus': InvoiceReviewStatusToJSON(value.reviewStatus),
        'billingStatus': InvoiceBillingStatusToJSON(value.billingStatus),
        'calculationStatus': InvoiceCalculationStatusToJSON(value.calculationStatus),
    };
}

